module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    key: _vm.handler,
    staticClass: "ql-selection-cue-marker",
    style: (_vm.style()),
    attrs: {
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cuePosWidth,
      "h": _vm.cuePosHeight,
      "minw": 10,
      "minh": 10,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked,
      "resizable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "resizestop": _vm.onResize,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.selectForCopy.apply(null, arguments)
      }
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.layer && _vm.layer.title + ' ' + _vm.cue.title))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57cdd7fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/cues/cue-selection-marker.vue
// module id = 1248
// module chunks = 21